module.exports = __webpack_public_path__ + "img/jx_sample2.85c90799.png";